import React from 'react';

import { FormattedMessage } from 'react-intl';

import LockIcon from '@atlaskit/icon/core/lock-locked';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { IconColor } from '@atlaskit/tokens/css-type-schema';
import Tooltip from '@atlaskit/tooltip';
import type { ThirdPartyRestrictionLevel } from '@atlassian/search-client/search-page/types';

import { messages } from './messages';

const defaultIconColor = token('color.icon');

type RestrictedLozengeProps = {
	permissionLevel: ThirdPartyRestrictionLevel | null;
	iconColour?: IconColor;
};

export const LOZENGE_TEST_ID = 'restricted-lozenge';

export const RestrictedIcon = ({
	permissionLevel,
	iconColour,
}: RestrictedLozengeProps): React.JSX.Element | null => {
	if (!permissionLevel || permissionLevel === 'public') {
		return null;
	}
	const tooltipText =
		permissionLevel === 'private' ? messages.privateTooltip : messages.restrictedTooltip;

	return (
		<Tooltip content={<FormattedMessage {...tooltipText} />}>
			<Box testId={LOZENGE_TEST_ID}>
				<LockIcon label="" color={iconColour ?? defaultIconColor} size="small" />
			</Box>
		</Tooltip>
	);
};
